import React, { Component } from 'react';
import { connect } from 'dva';
import { stringify } from 'qs';
import Container from '../../../../../../components/Container';
import ListPage from '../../../../../../components/ListPage';
import { columns, editorColums } from '../tableHeader';
import Common from '../../Common';
import { GetQueryString, getAppCode } from '../../../utils/utils';
import { url } from '../../../services/service-utils';

@connect(({ schoolManuscriptStatistics, user }) => ({
  ...schoolManuscriptStatistics,
  orgId: user.currentUser.orgId,
}))
class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      loading: false,
      totalElements: 0,
      params: {
        searchOrgName: '',
        appCode: getAppCode(),
        nodeId: GetQueryString('nodeId'),
        page: 1,
        pageSize: 10,
        startMonth: GetQueryString('startMonth'),
        endMonth: GetQueryString('endMonth'),
        isPerson: GetQueryString('isPerson'),
      },
    };
    this.activeKey = GetQueryString('activeKey');
    this.type = GetQueryString('type');
    this.unlisten = null;
  }

  componentDidMount() {
    const { params } = this.state;
    const { history } = this.props;
    if (history && history.listen) {
      this.unlisten = history.listen(historyLocation => {
        const { query } = historyLocation;
        const { nodeId } = query;
        this.type = GetQueryString('type');
        if (nodeId) {
          this.fetchReportNode({ ...params, nodeId });
        }
      });
    }
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  fetchReportNode = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    console.log('this.type', this.type);
    dispatch({
      type: `schoolManuscriptStatistics/${
        this.type === 'editor' ? 'fetchReportDetail' : 'fetchReportNode'
      }`,
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: res.content,
          totalElements: res.totalElements,
          params,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchReportNode(tempParams);
  };

  downLoadUrl = () => {
    const { orgId } = this.props;
    const { params, activeKey } = this.state;
    const reportNodeExport = `${url.url}/web/news/statistics/reportNodeExport?${stringify(params)}`;
    const reportDetailExport = `${url.url}/web/news/statistics/reportDetailExport?${stringify(
      params
    )}`;
    const reportAllExport = `${url.url}/web/news/statistics/reportAllExport?${stringify({
      ...params,
      nodeId: orgId,
    })}`;
    const reportDetailAllExport = `${url.url}/web/news/statistics/reportDetailAllExport?${stringify(
      {
        ...params,
        nodeId: orgId,
      }
    )}`;

    return {
      list: this.type === 'editor' ? reportDetailExport : reportNodeExport,
      all: activeKey === 'key1' ? reportAllExport : reportDetailAllExport,
    };
  };

  render() {
    const { loading, dataSource, params, totalElements } = this.state;
    const { page, startMonth, endMonth, isPerson } = params;

    const pageProps = {
      spinProps: { spinning: loading },
    };

    const columnsparams = { startMonth, endMonth, activeKey: this.activeKey, isPerson };

    const col = {
      detail: columns(columnsparams),
      editor: editorColums,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns: col[this.type],
      list: dataSource,
      rowKey: 'id',
      onPageChange: this.changePage,
    };

    const downUrl = this.downLoadUrl();

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <Common tableProps={tableProps} downUrl={downUrl} />
        </ListPage>
      </Container>
    );
  }
}

export default Detail;
